<template>
  <div class="crs-box">
    <div class="coordinates-box">
      <div class="content-box">
        <div class="coordinates-type-box">
          <div class="radio-group-box">
            <el-radio-group
              class="radio-primary"
              v-model="coordinatesType"
              :disabled="disabled"
              @input="handleRadioChange">
              <div class="common-radio-box">
                <el-radio label="EPSG">EPSG编码</el-radio>
              </div>
              <div class="common-radio-box">
                <el-radio label="WKT">WKT字符串</el-radio>
              </div>
              <div
                class="common-radio-box"
                v-if="dataType.includes('dataSet')">
                <el-radio label="CalibrationPoint">校准点经纬度</el-radio>
              </div>
              <div class="common-radio-box">
                <el-radio label="None">无</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="coordinates-content-box">
          <div
            class="common-select-box"
            v-if="coordinatesType === 'EPSG'">
            <el-select
              class="primary-select"
              size="small"
              remote
              filterable
              v-model="epsg"
              :loading="loading"
              :remote-method="filterEpsg"
              :disabled="disabled"
              popper-class="primary-select-outer"
              placeholder="请选择或通过EPSG编码搜索">
              <div v-infinite-scroll="handleScroll">
                <el-option
                  v-for="(item, index) in epsgList"
                  :key="index"
                  :label="item.shortHand"
                  :value="item.shortHand">
                  <div class="option-box">
                    <div>{{ item.shortHand }}</div>
                    <div
                      class="desName-box text-overflow"
                      :title="item.desName">
                      {{ item.desName }}
                    </div>
                  </div>
                </el-option>
              </div>
            </el-select>
          </div>
          <div
            class="wkt-box"
            v-if="coordinatesType === 'WKT'">
            <div class="common-upload-box">
              <el-upload
                accept=".prj"
                name="FileInfo"
                :action="projUploadAction"
                :show-file-list="false"
                :before-upload="onBeforeUpload"
                :on-success="onUploadSuccess"
                :on-error="onUploadError"
                :disabled="fileUpLoading">
                <div
                  class="file-name-box"
                  v-if="fileUpLoaded">
                  <icon-svg
                    icon-class="ic-file"
                    class="icon" />
                  <span
                    class="text-overflow"
                    :title="fileName">
                    {{ fileName }}
                  </span>
                  <span>
                    <i
                      class="el-icon-close icon"
                      title="删除文件"
                      @click.stop="removeFile" />
                  </span>
                </div>
                <div
                  class="common-button-box"
                  v-else>
                  <el-button
                    class="primary-btn"
                    type="primary"
                    size="small">
                    <span>从本地prj文件读取</span>
                    <i
                      v-if="fileUpLoading"
                      class="el-icon-loading el-icon--right" />
                  </el-button>
                </div>
              </el-upload>
            </div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="medium"
                type="textarea"
                :disabled="fileUpLoaded"
                placeholder="请输入标准格式的WKT字符串"
                :rows="5"
                :maxlength="2000"
                show-word-limit
                v-model="wktString" />
            </div>
          </div>
          <div
            class="latlng-box"
            v-show="coordinatesType === 'CalibrationPoint'">
            <div class="item-box">
              <div class="label dialog-label">校准点坐标：</div>
              <div class="input-box">
                <div class="item">
                  <div class="dialog-label">x：</div>
                  <div class="common-input-box">
                    <el-input
                      class="input-primary"
                      size="small"
                      v-model="calibrationPoint.x" />
                  </div>
                </div>
                <div class="item">
                  <div class="dialog-label">y：</div>
                  <div class="common-input-box">
                    <el-input
                      class="input-primary"
                      size="small"
                      v-model="calibrationPoint.y" />
                  </div>
                </div>
                <div class="item">
                  <div class="dialog-label">z：</div>
                  <div class="common-input-box">
                    <el-input
                      class="input-primary"
                      size="small"
                      v-model="calibrationPoint.z" />
                  </div>
                </div>
              </div>
            </div>
            <div class="item-box">
              <div class="content-box">
                <div class="label next-line dialog-label">校准点经度(°)：</div>
                <div class="common-input-box loglatData">
                  <el-input
                    class="input-primary"
                    size="small"
                    v-model="calibrationPoint.lng" />
                </div>
              </div>
              <div class="content-box">
                <div class="label dialog-label">校准点纬度(°)：</div>
                <div class="common-input-box calibrtionlog">
                  <el-input
                    class="input-primary"
                    size="small"
                    v-model="calibrationPoint.lat" />
                </div>
              </div>
              <div
                class="icon-box"
                @click="openMapDialog"
                v-if="!baiduDisabled">
                <icon-svg
                  icon-class="ic-dingwei1"
                  class="icon" />
              </div>
            </div>
          </div>
          <div
            class="tip-content-box public-tips-primary"
            v-if="dataType.includes('Plane') && coordinatesType === 'None'">
            场景坐标为无时，所有转换成功过的数据集都可以添加到场景，但位置无法自动匹配
          </div>
        </div>
      </div>
    </div>
    <DragDialog
      title="选择经纬度"
      :width="600"
      :visible.sync="mapDialogVisible"
      :footerBtn="['cancel', 'submit']"
      :submit="submitLatLng"
      :cancel="closeMapDialog">
      <div class="map-container">
        <div
          id="map"
          class="map-box"></div>
        <div class="coordiante-box">
          <div class="item-box">
            <div class="dialog-label">经度(°)：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="latLng.lng">
              </el-input>
            </div>
          </div>
          <div class="item-box">
            <div class="dialog-label">纬度(°)：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="latLng.lat">
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </DragDialog>
  </div>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { queryCrsList } from '@/service/interface'

const mapboxgl = window.mapboxgl
const MapboxLanguage = window.MapboxLanguage
const MapboxGeocoder = window.MapboxGeocoder
mapboxgl.accessToken =
  'pk.eyJ1IjoiY2htMTc4MSIsImEiOiJjaXI0YWk3a3QwMWx5ZnBubTFuY3d2enZvIn0.zDEUyiEq9gGb69B8qki9Tg'
export default {
  data() {
    return {
      coordinatesType: 'EPSG',

      epsg: '',
      loading: false,
      epsgList: [],
      currentPage: 1,
      pageSize: 20,

      projUploadAction: this.getProjUploadAction(),
      fileUpLoaded: false,
      fileUpLoading: false,
      fileName: '',
      wktString: '',

      baiduDisabled: window.baiduDisabled,
      mapDialogVisible: false,
      latLng: {
        lat: '',
        lng: ''
      },
      calibrationPoint: {
        x: '0',
        y: '0',
        z: '0',
        lat: '',
        lng: ''
      }
    }
  },
  props: {
    dataType: String,
    disabled: Boolean,
    crsInfo: Object
  },
  components: {
    DragDialog
  },
  mounted() {
    this.initCrs()
  },
  methods: {
    initCrs() {
      let crsInfo = this.crsInfo
      let coordinatesType = crsInfo.crsType
      if (coordinatesType === 'EPSG') {
        this.initEpsgList()
      }

      if (!crsInfo.crsType) return

      if (crsInfo.crsType) {
        this.coordinatesType = coordinatesType
        if (coordinatesType === 'EPSG') {
          this.epsg = crsInfo.crsString
        }
        if (coordinatesType === 'WKT') {
          this.wktString = crsInfo.crsString
        }
        if (coordinatesType === 'CalibrationPoint') {
          let { x, y, z, lng, lat } = crsInfo
          this.calibrationPoint.x = x
          this.calibrationPoint.y = y
          this.calibrationPoint.z = z
          this.calibrationPoint.lng = lng
          this.calibrationPoint.lat = lat
        }
      }
    },
    initEpsgList() {
      this.queryEpsgList().then(epsgList => {
        this.epsgList = epsgList
      })
    },
    handleRadioChange(value) {
      switch (value) {
        case 'EPSG':
          this.removeFile()
          this.resetCalibrationPoint()

          this.initEpsgList()
          break
        case 'WKT':
          this.resetEpsg()
          this.resetCalibrationPoint()
          break
        case 'CalibrationPoint':
          this.resetEpsg()
          this.removeFile()
          break
        case 'None':
          this.resetEpsg()
          this.removeFile()
          this.resetCalibrationPoint()
          break
      }
    },
    handleScroll() {
      if (this.allEpsgLoaded || this.keyWord) return
      this.currentPage++
      this.queryEpsgList().then(epsgList => {
        if (epsgList.length) {
          this.epsgList = [...this.epsgList, ...epsgList]
        } else {
          this.allEpsgLoaded = true
        }
      })
    },
    filterEpsg(keyWord) {
      this.currentPage = 1
      this.allEpsgLoaded = false
      this.keyWord = keyWord

      this.loading = true
      this.queryEpsgList().then(epsgList => {
        this.epsgList = epsgList
        this.loading = false
      })
    },
    queryEpsgList() {
      return new Promise(resolve => {
        let params = {
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize,
          keyWord: this.keyWord
        }
        queryCrsList(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let epsgList = data.items
            resolve(epsgList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    resetEpsg() {
      this.epsg = ''
      this.loading = false
      this.currentPage = 1
      this.keyWord = ''
      this.allEpsgLoaded = false
      this.initEpsgList()
    },
    onBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('文件大小不能超过2M')
        return false
      }
      this.fileUpLoading = true
    },
    onUploadSuccess(response, file) {
      this.fileUpLoaded = true
      this.fileUpLoading = false
      if (response.isSuccess) {
        this.fileUpLoaded = true
        this.fileName = file.name
        let wktString = response.data
        if (wktString.length > 2000) {
          this.$message.warning('文件内容超出长度限制，请重新上传')
        }
        this.wktString = response.data
      } else {
        this.$message.error(response.errMsg)
        this.removeFile()
      }
    },
    onUploadError() {
      this.fileUpLoading = false
      this.$message.error('文件上传失败')
    },
    removeFile() {
      this.fileName = ''
      this.wktString = ''
      this.fileUpLoading = false
      this.fileUpLoaded = false
    },
    openMapDialog() {
      this.mapDialogVisible = true
      this.$nextTick(() => {
        this.initMap()
      })
    },
    submitLatLng() {
      this.calibrationPoint.lng = this.latLng.lng
      this.calibrationPoint.lat = this.latLng.lat
      this.closeMapDialog()
    },
    closeMapDialog() {
      if (this.marker) {
        this.marker.remove()
        this.marker.off('dragend', this.onDragEnd)
        this.marker = null
      }

      this.latLng = {
        lng: '',
        lat: ''
      }

      this.mapDialogVisible = false
    },
    initMap() {
      this.getCurrLocation().then(center => {
        this.map = new mapboxgl.Map({
          container: 'map',
          center: center,
          zoom: 10
        })
        let mapboxglLanguage = new MapboxLanguage({ defaultLanguage: 'zh' })
        let mapboxGeoCoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl
        })
        this.map.addControl(mapboxGeoCoder, 'top-left')
        this.map.addControl(mapboxglLanguage)

        this.addLayer()
        if (this.calibrationPoint.lng && this.calibrationPoint.lat) {
          let { lng, lat } = this.calibrationPoint
          this.latLng.lng = lng
          this.latLng.lat = lat
          this.addMarker(lng, lat)
        }

        this.map.on('load', this.onMapboxLoaded)
      })
    },
    onMapboxLoaded() {
      this.map.on('click', this.mapOnClick)
    },
    mapOnClick(event) {
      let lngLat = event.lngLat
      let { lng, lat } = lngLat
      this.latLng.lng = lng.toFixed(6)
      this.latLng.lat = lat.toFixed(6)

      this.addMarker(lng, lat)
    },
    onDragEnd() {
      const lngLat = this.marker.getLngLat()
      let { lng, lat } = lngLat
      this.latLng.lng = lng.toFixed(6)
      this.latLng.lat = lat.toFixed(6)
    },
    addLayer() {
      this.map.addLayer({
        id: 'basemap_vec',
        type: 'raster',
        source: {
          type: 'raster',
          tiles: [
            'https://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=8e04b331aecb449ee0974b9b59d7f397'
          ],
          tileSize: 256
        }
      })
      this.map.addLayer({
        id: 'basemap_cva',
        type: 'raster',
        source: {
          type: 'raster',
          tiles: [
            'https://t0.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=8e04b331aecb449ee0974b9b59d7f397'
          ],
          tileSize: 256
        }
      })
    },
    addMarker(lng, lat) {
      if (this.marker) {
        this.marker.remove()
        this.marker.off('dragend', this.onDragEnd)
        this.marker = null
      }

      const lngLat = new mapboxgl.LngLat(Number(lng), Number(lat))
      this.marker = new mapboxgl.Marker({ draggable: true })
      this.marker.setLngLat(lngLat)
      this.marker.addTo(this.map)

      this.marker.on('dragend', this.onDragEnd)
    },
    getCurrLocation() {
      return new Promise(resolve => {
        let BMapGL = window.BMapGL
        let localCity = new BMapGL.LocalCity()
        localCity.get(result => {
          let lngLat = result.center
          let center = [lngLat.lng, lngLat.lat]
          resolve(center)
        })
      })
    },
    resetCalibrationPoint() {
      if (this.map) {
        this.map.off('click', this.mapOnClick)
        this.map.off('load', this.onMapboxLoaded)
        this.map.remove()
        this.map = null
      }

      this.latLng = {
        lat: '',
        lng: ''
      }
      this.calibrationPoint = {
        x: '0',
        y: '0',
        z: '0',
        lat: '',
        lng: ''
      }
    },
    clearForm() {
      this.coordinatesType = 'EPSG'
      this.resetEpsg()
      this.removeFile()
      this.resetCalibrationPoint()
    },
    getCrsParams() {
      let crsParams = {
        coordinatesType: this.coordinatesType
      }
      if (this.coordinatesType === 'EPSG') {
        if (!this.epsg) {
          this.$message.warning('请选择EPSG编码')
          return
        }
        crsParams.coordinates = this.epsg
      }
      if (this.coordinatesType === 'WKT') {
        if (!this.wktString) {
          this.$message.warning('请读取或输入WKT字符串')
          return
        }
        crsParams.coordinates = this.wktString
      }
      if (this.coordinatesType === 'CalibrationPoint') {
        let { x, y, z, lat, lng } = this.calibrationPoint
        if (!lng || !lat) {
          this.$message.warning('请输入或选取校准点经纬度')
          return
        }

        if (
          !this.isPointValueValid(x) ||
          !this.isPointValueValid(y) ||
          !this.isPointValueValid(z)
        ) {
          this.$message.warning('校准点整数部分最多9位，小数部分3位')
          return
        }
        crsParams.coordinates = `${x},${y},${z}`
        if (!this.isLngValid(lng)) {
          this.$message.warning('经度限制范围-180到180，小数部分最大长度8位')
          return
        }
        if (!this.isLatValid(lat)) {
          this.$message.warning('纬度限制范围-90到90，小数部分最大长度8位')
          return
        }
        crsParams.longitude = lng
        crsParams.latitude = lat
      }
      if (this.coordinatesType === 'None') {
        crsParams.coordinates = ''
        crsParams.longitude = ''
        crsParams.latitude = ''
      }

      return crsParams
    },
    isPointValueValid(point) {
      point = Number(point).toString()
      let integerPart = point.split('.')[0]
      let decimalPart = point.split('.')[1]
      if (integerPart.length > 9 || (decimalPart && decimalPart.length > 3)) {
        return false
      } else {
        return true
      }
    },
    isLngValid(lng) {
      lng = Number(lng)
      let string = lng.toString()
      let decimalPart = string.split('.')[1]
      let isValid = false
      if (lng > -180 && lng < 180) {
        if (decimalPart) {
          isValid = decimalPart.length < 9 ? true : false
        } else {
          isValid = true
        }
      } else {
        isValid = false
      }
      return isValid
    },
    isLatValid(lat) {
      lat = Number(lat)
      let string = lat.toString()
      let decimalPart = string.split('.')[1]
      let isValid = false
      if (lat > -90 && lat < 90) {
        if (decimalPart) {
          isValid = decimalPart.length < 9 ? true : false
        } else {
          isValid = true
        }
      } else {
        isValid = false
      }
      return isValid
    },
    getProjUploadAction() {
      let actionUrl = `${window.serverUrl}/${this.$logServeCof()}/project/baseData/getFileCrs`
      return actionUrl
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.coordinates-box {
  color: var(--page-text-color);
  font-size: 14px;
  font-weight: 400;

  .content-box {
    .coordinates-type-box {
      display: flex;
      align-items: baseline;
      .label {
        width: 100px;
        text-align: right;
      }
      .radio-group-box {
        width: 100%;
        .el-radio-group {
          display: flex;
        }

        /deep/ .el-radio {
          // 防止出现控制台报错
          input[aria-hidden='true'] {
            display: none !important;
          }
        }
      }
    }
    .coordinates-content-box {
      .common-select-box {
        margin-top: 8px;
        .el-select {
          width: 100%;
        }
      }
      .wkt-box {
        margin: 8px auto;

        .file-name-box {
          display: flex;
          align-items: center;
          background: var(--base-bg-light-color56);
          border: 1px solid var(--base-dark35-color);
          border-radius: 4px;
          padding: 4px 0;
          font-size: 12px;
          font-weight: 400;
          color: var(--base-dark35-color);

          .icon {
            margin: 0px 4px;
            .svg-icon {
              color: var(--base-dark35-color);
            }
          }
        }

        .common-input-box {
          margin-top: 10px;

          :deep(.el-textarea__inner) {
            padding-right: 54px;
            font-family: none;

            // &::placeholder {
            //   font-family: '' Source Han Sans CN
            //     ', Rototo, Emoji, Helvetica, Arial, sans-serif';
            //   font-size: 14px;
            //   font-weight: 400;
            //   font-size: 14px;
            //   // color: var();
            // }
          }
        }
      }
      .latlng-box {
        margin: 10px auto;

        .item-box {
          display: flex;
          line-height: 32px;
          align-items: center;

          .label {
            flex-shrink: 0;
            text-align: left;
          }
          .input-box {
            display: flex;
            // margin-left: 10px;
            .item {
              display: flex;
              margin-left: 10px;
            }
          }
          .content-box {
            margin-top: 8px;
            margin-right: 10px;
            padding: 0px;
            background: unset;
            display: flex;

            .next-line {
              margin-left: 6px;
            }

            .common-input-box {
              width: 150px;
              margin-left: 10px;
            }

            .calibrtionlog {
              width: 100%;
            }
          }
          .icon-box {
            color: var(--icon-dark-color);
            cursor: pointer;
            margin-top: 9px;
            &:hover{
              color: var(--base-primary-bgColor);
            }
          }
        }
      }
      .tip-content-box {
        width: 420px;
        margin-top: 8px;
        line-height: 20px;
      }
    }
  }
}

.map-container {
  height: 500px;
  margin-top: 10px;
  .map-box {
    height: 450px;
  }
  .coordiante-box {
    display: flex;
    margin-top: 10px;
    line-height: 32px;
    color: var(--default-color);

    .item-box {
      display: flex;
      margin-right: 10px;
    }
  }
}
</style>
